"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomContainerType = void 0;
var _react = require("react");
var useCustomContainerType = exports.useCustomContainerType = function useCustomContainerType(isMobileMode, containerType) {
  var customContainerType = (0, _react.useMemo)(function () {
    if (typeof containerType === 'function') {
      return containerType(isMobileMode);
    }
    return containerType;
  }, [containerType, isMobileMode]);
  return customContainerType;
};